export default {"src":"/_next/static/media/no-students.20b74032.svg","height":200,"width":200};